import React from "react";
import "./stub-page.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { normalizeLocale } from "@/i18n";

/**
 * Themed placeholder for routes that are registered but not yet built.
 * Renders through the same CSS variable system as real pages so it already
 * matches the active static appearance (light/dark) instead of
 * looking like a broken/unstyled page.
 */
export function StubPage({ titleKey }: { titleKey: string }) {
    const { t: translate, i18n } = useTranslation();
    const locale = normalizeLocale(i18n.language);
    const navigate = useNavigate();
    const title = translate(titleKey) as string;

    return (
        <div className="stub-page">
            <div className="stub-page__card">
                <p className="stub-page__eyebrow">{translate("stub.comingSoon")}</p>
                <h1 className="stub-page__title" dir="auto">{title}</h1>
                <button type="button" className="stub-page__back" onClick={() => navigate(`/${locale}`)}>
                    {translate("stub.backHome")}
                </button>
            </div>
        </div>
    );
}
